import React from 'react';
import { Link } from 'react-admin';

interface Props {
    record?: any;
    source?: string;
    link?: string | boolean;
    activeOnly?: boolean;
}

const WarehouseReferenceField: React.FC<Props> = ({
    record,
    source = 'warehouseId',
    link = 'show',
    activeOnly = false,
}) => {
    if (!record) {
        return null;
    }

    // Get the warehouse data from either the nested warehouse object or the direct fields
    const warehouse = record.warehouse || {};
    const warehouseId = warehouse.id || record.warehouseId;
    if (!warehouseId) {
        return null;
    }

    const warehouseName = warehouse.name || record.warehouseName;
    if (!warehouseName) {
        return null;
    }

    // Check if the warehouse is active when activeOnly is true
    const isActive =
        warehouse.active !== undefined
            ? warehouse.active
            : record.warehouseActive;
    if (activeOnly && !isActive) {
        return null;
    }

    // Display the warehouse name with an optional link to the warehouse
    if (link) {
        return (
            <Link to={`/warehouses/${warehouseId}/show`}>{warehouseName}</Link>
        );
    }

    return <span>{warehouseName}</span>;
};

export default WarehouseReferenceField;
